import { Component } from '@angular/core';
import { AnimationOptions,AnimationLoader } from 'ngx-lottie';

@Component({
  providers:[
    AnimationLoader,
  ],
  selector: 'app-oauth-loading',
  templateUrl: './oauth-loading.component.html',
  styleUrls: ['./oauth-loading.component.scss']
})
export class OauthLoadingComponent {
  options: AnimationOptions = {
    path: 'assets/lottie/share_india_loop.json'
  }

  constructor(){ }

}
